
import CardPropertyTable from '../../components/Card/CardPropertyTable.vue'
import EmployeeSkillCard from './EmployeeSkillCard.vue'
import EmployeeAdmittanceCard from './EmployeeAdmittanceCard.vue'
import { cardPropertyObject } from '../../components/Card/CardPropertyObject.js'
import { deleteDocumentFromAdmittanceRecord } from './EmployeeAdmittanceRecord.js'
import FilesGroup from '../../components/File/FilesGroup.js'

export default {
  name: 'EmployeePropertySkills',
  extends: CardPropertyTable,
  mixins: [cardPropertyObject],
  data: function () {
    let componentProps = this.tabProp.componentProps
    if (!componentProps) {
      componentProps = {}
      this.$set(this.tabProp, 'componentProps', componentProps)
    }
    // Если колонка одна, то не отображаем заголовок и пэйджинацию
    if (!componentProps.columns || componentProps.columns.length <= 1) {
      this.$set(componentProps, 'rowsPerPage', 0)
      this.$set(componentProps, 'hideHeader', true)
      this.$set(componentProps, 'hideBottom', true)
      // componentProps.rowsPerPage = 0
      // componentProps.hideHeader = true
      // componentProps.hideBottom = true
    }

    const deleteIconName = componentProps.admittance && componentProps.admittanceType === 'skillAdmittanceCertificate' ? 'mdi-alpha-a-box' : 'mdi-delete'
    const deleteButtonTooltipText = componentProps.admittance && componentProps.admittanceType === 'skillAdmittanceCertificate' ? 'Переместить в архив' : 'Удалить'

    return {
      addFn: () => this.onShowObjectCard(null), // @Override
      deleteIconName: deleteIconName, // @Override
      deleteButtonTooltipText: deleteButtonTooltipText // @Override
    }
  },
  computed: {
    columns: function () {
      let columnsProps
      const columns = this.componentProps.columns
      if (columns && columns.length) {
        columnsProps = columns
      } else {
        columnsProps = [{ name: 'name', label: 'Название', type: 'string' }]
      }
      return columnsProps.map(o => this.getColumnConfig(o))
    },
    rows: function () {
      if (this.object && this.tabProp) {
        const value = this.object[this.tabProp.key]
        if (value == null) {
          // !!! Преобразование вынесено в ObjectCard.setObject()
          // value = []
          // this.$set(this.object, this.tabProp.key, value)
          throw new Error(`Значение ссылочного параметра "${this.tabProp.key}" равно null`)
        }
        return this.getRowsFiltered()
      }
      return []
    }
  },
  // created: function () {
  //   this.tabProp.editable = this.$d_hasOperation('changeEmployeeSkills', true)
  // },
  methods: {
    // @Override
    onRowClick: function ($event, row) {
      // this.$d_showObjectCard(row.id, row.type, $event.ctrlKey)
      this.onShowObjectCard(row)
    },

    // @Override
    onDeleteRow: function (row) {
      const rows = this.getRowsFiltered()
      const index = rows.indexOf(row)
      if (this.componentProps.admittance && this.componentProps.admittanceType === 'skillAdmittanceCertificate') {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              let indexInOriginalArray = this.object.skillAdmittance.indexOf(row)
              if (indexInOriginalArray === -1) {
                indexInOriginalArray = this.object.skillRequiredAdmittance.indexOf(row)
                this.object.skillArchive.unshift(this.object.skillRequiredAdmittance[indexInOriginalArray])
                this.object.skillRequiredAdmittance.splice(indexInOriginalArray, 1)
              } else {
                this.object.skillArchive.unshift(this.object.skillAdmittance[indexInOriginalArray])
                this.object.skillAdmittance.splice(index, 1)
              }
            }
          },
          header: 'Переместить удостверение в архив?',
          buttons: {
            yes: 'Переместить',
            no: 'Отмена'
          }
        })
      } else {
        rows.splice(index, 1)
      }
    },

    // @Override
    isRowReadonly: function (row) {
      if (this.componentProps.admittance && this.componentProps.admittanceType === 'requiredAdmittance') {
        return !row.isHandAdded
      } else if (this.componentProps.admittance && this.componentProps.admittanceType === 'skillAdmittanceCertificate') {
        return row.hasToReturnCard
      } else {
        return false
      }
    },

    // @Override
    getTrStyle: function (row) {
      const index = this.getRowsFiltered().findIndex(r => r.id === row.id)
      if (index % 2 !== 0) {
        return 'background-color: #EDF6FF'
      } else {
        return ''
      }
    },

    getRowsFiltered: function () {
      if (this.componentProps.admittance && this.componentProps.admittanceType !== 'skillAdmittanceCertificate') {
        return this.object[this.tabProp.key]
      } else if (this.componentProps.admittance) {
        return [
          ...this.object.skillAdmittance.filter(adm => this.hasDocument(adm)),
          ...this.object.skillRequiredAdmittance.filter(adm => this.hasDocument(adm))
        ].sort((r1, r2) => {
          let result = r1.name.localeCompare(r2.name)
          if (result !== 0) {
            return result
          }
          result = r1.qualificationTypeKey.localCompare(r2.qualificationTypeKey)
          if (result !== 0) {
            return result
          }
          result = r1.planReceiveTime - r2.planReceiveTime
          if (result !== 0) {
            return result
          }
          result = r1.qualificationGroup.localCompare(r2.qualificationGroup)
          return result
        })
      } else {
        return this.object[this.tabProp.key]
      }
    },

    hasDocument: function (admittance) {
      return admittance.docN || admittance.document.length > 0 || admittance.startValidTime || admittance.endValidTime
    },

    onShowObjectCard: function (record) {
      const admittance = !!this.componentProps.admittance
      const admittanceType = this.componentProps.admittanceType
      const blocked = this.componentProps.admittanceType === 'blockedAdmittance'
      const records = this.object[this.tabProp.key]

      if (admittance && ['requiredAdmittance', 'nonRequiredAdmittance', 'blockedAdmittance'].includes(admittanceType)) { // Секции Обязательных и Необязательных допусков
        const alreadyAddedQualificationTypesKeys = new Set([...this.object.skillRequiredAdmittance, ...this.object.skillAdmittance].map(record => record.qualificationTypeKey))
        this.$d.dialog(this).show({
          maximized: false,
          persistent: true,
          headerLabel: admittanceType === 'requiredAdmittance' ? 'Обязательный вид допуска (квалификации)' : admittanceType === 'nonRequiredAdmittance' ? 'Необязательный вид допуска (квалификации)' : 'Заблокированный вид допуска (квалификации)',
          contentComponent: EmployeeAdmittanceCard,
          contentProps: {
            admittance: admittance,
            blocked: blocked,
            record: record || null,
            records: records,
            alreadyAddedQualificationTypesKeys: alreadyAddedQualificationTypesKeys,
            readonly: !this.tabProp.editable,
            requiredAdmittance: admittanceType === 'requiredAdmittance'
          }
        })
      } else { // Секция Навыки или Удостоверения
        const allRecords = admittance ? [
          ...this.object.skillAdmittance.filter(adm => !this.hasDocument(adm)),
          ...this.object.skillRequiredAdmittance.filter(adm => !this.hasDocument(adm))
        ] : records
        const admittanceReadonly = admittance && (!this.object.skillAdmittance.length && !this.object.skillRequiredAdmittance.length || this.getRowsFiltered().length == this.object.skillAdmittance.length + this.object.skillRequiredAdmittance.length) && !record
        const emptyAdmittanceListWarning = !this.object.skillAdmittance.length && !this.object.skillRequiredAdmittance.length ? 'Сначала необходимо добавить обязательный или необязательный вид допуска' : 'Для всех видов допуска уже добавлены удостоверения'
        this.$d.dialog(this).show({
          maximized: false,
          persistent: true,
          headerLabel: admittance ? 'Удостоверение' : 'Навык',
          contentComponent: EmployeeSkillCard,
          contentProps: {
            admittance: admittance,
            admittanceType: admittanceType,
            record: record || null,
            records: allRecords,
            skillRequiredAdmittance: this.object.skillRequiredAdmittance,
            skillAdmittance: this.object.skillAdmittance,
            readonly: !this.tabProp.editable || admittanceReadonly,
            showEmptyAdmittanceListWarning: admittanceReadonly,
            emptyAdmittanceListWarning: emptyAdmittanceListWarning,
            objectInitial: this.objectInitial
          }
        })
      }
    }
  }
}
